import React from "react";
import { useNavigate, Outlet, useParams } from "react-router-dom";
import useAuth from "../../contexts/UserContext.tsx";
import Navbar from "../navbar/Navbar";
import SidebarMathlab from "../sidebarMathlab/SidebarMathlab.jsx";
import "./privatelayout.scss";

const MathlabLayout = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { id } = useParams();
  React.useEffect(() => {
    if (
      parseInt(id) !== parseInt(user.view_access_list.schoolID) ||
      !user.view_access_list.mathlab
    ) {
      return <h1>Unauthorized</h1>;
    }
    if (
      parseInt(id) === parseInt(user.view_access_list.schoolID) &&
      user.view_access_list.smartclass &&
      user.view_access_list.mathlab
    ) {
      navigate(`/dashboard/school/${id}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const user = true
  return user ? (
    <div className="mainLayout">
      <Navbar />
      <div className="subLayout">
        <SidebarMathlab />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  ) : (
    navigate("/login")
  );
};

export default MathlabLayout;
